import { Navigate } from 'react-router-dom';
import { useIsSuperAdmin } from '@/hooks/useRole';

interface SuperAdminRouteProps {
  children: React.ReactNode;
}

/**
 * Wraps any /root/* route.
 * Silently redirects non-superadmin users to /dashboard.
 */
export default function SuperAdminRoute({ children }: SuperAdminRouteProps) {
  const isSuperAdmin = useIsSuperAdmin();
  if (!isSuperAdmin) {
    return <Navigate to="/dashboard" replace />;
  }
  return <>{children}</>;
}
